import React from "react";

const Phone = ({width,height}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.824 19.0741V1.70696C10.9934 0.777939 8.96975 0.310438 6.92396 0.34397C4.86021 0.314354 2.8181 0.774437 0.959961 1.68765V19.1127C2.85274 20.0174 4.92358 20.4714 7.01496 20.4401C9.03405 20.4939 11.0333 20.0238 12.824 19.0741ZM11.506 4.33637H2.27896V2.54345C3.76143 1.96261 5.33821 1.67057 6.92696 1.68256C8.49486 1.66605 10.0508 1.96161 11.507 2.5526L11.506 4.33637ZM11.506 15.0725H2.27896V5.67699H11.506V15.0725ZM11.506 18.2508C10.0812 18.8408 8.55318 19.1299 7.01496 19.1005C5.39789 19.1147 3.79209 18.826 2.27796 18.2488V16.4132H11.505L11.506 18.2508ZM7.70596 17.6755C7.68206 17.4927 7.59956 17.3229 7.47123 17.1925C7.3429 17.062 7.17587 16.9782 6.99596 16.9539C6.87074 16.9372 6.74342 16.95 6.62385 16.9914C6.50427 17.0327 6.39564 17.1013 6.30633 17.1921C6.21703 17.2829 6.14945 17.3933 6.10881 17.5148C6.06818 17.6364 6.05557 17.7658 6.07196 17.893C6.09587 18.0759 6.17836 18.2457 6.3067 18.3761C6.43503 18.5065 6.60206 18.5904 6.78196 18.6147C6.90715 18.6311 7.03438 18.6182 7.15386 18.5768C7.27334 18.5354 7.38189 18.4667 7.47114 18.376C7.5604 18.2853 7.62798 18.175 7.66869 18.0535C7.7094 17.9321 7.72215 17.8028 7.70596 17.6755ZM8.86596 2.33915H4.91096V3.67876H8.86596V2.33915Z"
        fill="black"
      />
    </svg>
  );
};

Phone.defaultProps = {
  width: 13,
  height: 21,
}

export default Phone;
